import { Product } from "@typings/product/product";

export default ({ item, configuration }: Product) => {
  let quantity: string | undefined;

  const { options } = configuration;

  for (const optionId in options) {
    const option = item.options.find((o) => o.id === +optionId)!;
    const optionValueId = options[optionId];

    if (option.name === "Quantity")
      quantity = option.values.find((ov) => ov.id === optionValueId)!.name;
  }

  return `${quantity ? `${quantity} ` : ""} ${item.name}`;
};
